import {
    SET_DESTINATION_INFOGRAPHIC,
    SET_LISTINGS,
    SET_UNIT_REVIEWS,
    LOADING_LISTINGS,
    FAILED_LISTINGS,
    SET_DESTINATION_IMAGES,
    SET_INFOGRAPHIC_BOXES,
    SET_DESTINATIONS_DISCOVERY,
    SET_AFFINITIES,
    SET_LISTING_BADGE,
} from '../actions/action-types';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_DESTINATION_INFOGRAPHIC:
            return {
                ...state,
                infographic: action.payload,
            };
        case SET_UNIT_REVIEWS:
            return {
                ...state,
                reviews: action.payload,
            };
        case SET_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    inventoryCount: action.inventoryCount,
                    loading: false,
                },
                segments: action.filterTags,
                listings: action.listings,
                lastCardUrl: action.lastCardUrl,
                cachedListings: action.cachedListings,
            };
        case LOADING_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    failed: false,
                    loading: true,
                    key: action.segmentKey,
                    timeoutMs: action.timeoutMs,
                },
            };
        case FAILED_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    loading: false,
                    failed: true,
                    timeoutMs: state.segmentFilters.timeoutMs * 2,
                },
            };
        case SET_DESTINATION_IMAGES:
            return {
                ...state,
                destinationImages: action.payload,
            };
        case SET_DESTINATIONS_DISCOVERY:
            return {
                ...state,
                destinationsDiscovery: action.payload,
            };
        case SET_INFOGRAPHIC_BOXES:
            return {
                ...state,
                infographicBoxes: action.payload,
            };
        case SET_AFFINITIES:
            return {
                ...state,
                affinities: action.payload,
            };
        case SET_LISTING_BADGE:
            return {
                ...state,
                listings: state.listings.map((listing) => {
                    if (listing.tripleId === action.payload.tripleId) {
                        listing.badgesIds = action.payload.badgesIds;
                    }
                    return listing;
                }),
            };
        default:
            return state;
    }
};
